import { Customer, CustomerSite } from "@hydrologiq/gql-experience/graphql"
import Figure from "../generic/Figure"
import FigureContent from "../generic/FigureContent"
import { isCompactFigure } from "../generic/figureVariant"
import TrendIndicator from "../generic/TrendIndicator"

function CustomerEmissions({
  context,
  loading,
  error,
}: {
  context?: Customer | CustomerSite
  loading: boolean
  error: string | undefined
}) {
  const emissions = context?.co2e ?? undefined
  return (
    <Figure heading="Total emissions" error={error ?? undefined} loading={loading} compact={isCompactFigure("monitoring")}>
      <FigureContent.SubText>yesterday</FigureContent.SubText>
      <FigureContent.Value>
        {emissions !== undefined && emissions !== null ? `${Math.floor(emissions * 100) / 100} kg` : "0 kg"}
      </FigureContent.Value>
    </Figure>
  )
}

export default CustomerEmissions
